import { API } from "aws-amplify";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { getProjectDetails } from "actions/projects";

export const GET_SUBLOAD_MAGNITUDES_DOWNLOAD_TEMPLATE_REQUEST =
  "@@subloadMagnitudes/GET_SUBLOAD_MAGNITUDES_DOWNLOAD_TEMPLATE_REQUEST";
export const GET_SUBLOAD_MAGNITUDES_DOWNLOAD_TEMPLATE_SUCCESS =
  "@@subloadMagnitudes/GET_SUBLOAD_MAGNITUDES_DOWNLOAD_TEMPLATE_SUCCESS";
export const GET_SUBLOAD_MAGNITUDES_DOWNLOAD_TEMPLATE_FAILURE =
  "@@subloadMagnitudes/GET_SUBLOAD_MAGNITUDES_DOWNLOAD_TEMPLATE_FAILURE";

export function getSubloadMagnitudesDownloadTemplate(
  id = "",
  organisation,
  sample_table = true
) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_SUBLOAD_MAGNITUDES_DOWNLOAD_TEMPLATE_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_subload_magnitude&organisation=${organisation}&sample_table=${sample_table}`;
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_SUBLOAD_MAGNITUDES_DOWNLOAD_TEMPLATE_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_SUBLOAD_MAGNITUDES_DOWNLOAD_TEMPLATE_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_SUBLOAD_MAGNITUDES_LIST_REQUEST =
  "@@subloadMagnitudes/GET_SUBLOAD_MAGNITUDES_LIST_REQUEST";
export const GET_SUBLOAD_MAGNITUDES_LIST_SUCCESS =
  "@@subloadMagnitudes/GET_SUBLOAD_MAGNITUDES_LIST_SUCCESS";
export const GET_SUBLOAD_MAGNITUDES_LIST_FAILURE =
  "@@subloadMagnitudes/GET_SUBLOAD_MAGNITUDES_LIST_FAILURE";

export function getSubloadMagnitudesList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_SUBLOAD_MAGNITUDES_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_subload_magnitude&organisation=${organisation}&sample_table=false`;
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_SUBLOAD_MAGNITUDES_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_SUBLOAD_MAGNITUDES_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const DELETE_SUBLOAD_MAGNITUDES_LIST_REQUEST =
  "@@subloadMagnitudes/DELETE_SUBLOAD_MAGNITUDES_LIST_REQUEST";
export const DELETE_SUBLOAD_MAGNITUDES_LIST_SUCCESS =
  "@@subloadMagnitudes/DELETE_SUBLOAD_MAGNITUDES_LIST_SUCCESS";
export const DELETE_SUBLOAD_MAGNITUDES_LIST_FAILURE =
  "@@subloadMagnitudes/DELETE_SUBLOAD_MAGNITUDES_LIST_FAILURE";

export function deleteSubloadMagnitudesList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: DELETE_SUBLOAD_MAGNITUDES_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_subload_magnitude&organisation=${organisation}`;
      }

      const response = await API.del("usimAPI", url);
      dispatch({
        type: DELETE_SUBLOAD_MAGNITUDES_LIST_SUCCESS,
        payload: response,
      });
      dispatch(getProjectDetails(id));
    } catch (error) {
      dispatch({
        type: DELETE_SUBLOAD_MAGNITUDES_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const UPLOAD_SUBLOAD_MAGNITUDES_DATA_REQUEST =
  "@@subloadMagnitudes/UPLOAD_SUBLOAD_MAGNITUDES_DATA_REQUEST";
export const UPLOAD_SUBLOAD_MAGNITUDES_DATA_SUCCESS =
  "@@subloadMagnitudes/UPLOAD_SUBLOAD_MAGNITUDES_DATA_SUCCESS";
export const UPLOAD_SUBLOAD_MAGNITUDES_DATA_FAILURE =
  "@@subloadMagnitudes/UPLOAD_SUBLOAD_MAGNITUDES_DATA_FAILURE";

export function uploadSubloadMagnitudesData(
  id = "",
  organisation,
  file,
  columnMappings,
  callback
) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: UPLOAD_SUBLOAD_MAGNITUDES_DATA_REQUEST,
    });
    try {
      let url = "/presignedurl";
      if (id) {
        url = `${url}?project_id=${id}&table_name=in_subload_magnitude`;
      }

      if (!isEmpty(columnMappings)) {
        url = `${url}&column_mappings=${encodeURI(
          JSON.stringify(columnMappings)
        )}`;
      }

      const response = await API.get("usimAPI", url);

      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": file.type },
        body: file,
      };
      await fetch(response.uploadURL, requestOptions).then((response) => {
        if (response.status === 200) {
          toast.success("Data uploaded successfully!");
          setTimeout(() => {
            dispatch(getSubloadMagnitudesList(id, organisation));
          }, 2000);
          callback({
            success: true,
          });
        } else {
          dispatch({
            type: UPLOAD_SUBLOAD_MAGNITUDES_DATA_FAILURE,
            payload: {
              message: "Upload data failed.",
            },
          });
        }
      });

      dispatch({
        type: UPLOAD_SUBLOAD_MAGNITUDES_DATA_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: UPLOAD_SUBLOAD_MAGNITUDES_DATA_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}
